import FileService from '../../apiclients/FileService';
import { cloneDeep } from 'lodash';

class UpdateFileController {
    onFilenameChanged = async (currentFile, newFilename, oldFilename) => {
        try {
            let response = await FileService.updateFilename(currentFile.fileId, newFilename);
            return response;
        } catch (err) {
            console.log('err', err);
            currentFile.filename = oldFilename;
            return currentFile;
        }
    };

    onChangeShareable = async (currentFile, checked, oldShareable) => {
        try {
            let response = await FileService.updateShareable(currentFile.fileId, checked);
            return response;
        } catch (err) {
            console.log('err', err);
            currentFile.shareable = oldShareable;
            return currentFile;
        }
    };

    handleDeleteTag = async (currentFile, tag, oldTags) => {
        try {
            let response = await FileService.removeTagToFile(currentFile.fileId, tag);
            return response;
        } catch (err) {
            console.log('err', err);
            currentFile.tags = oldTags;
            return currentFile;
        }
    };

    handleAddTags = (currentFile, tags) => {
        const oldFile = cloneDeep(currentFile);
        if (!currentFile.tags) {
            currentFile.tags = {
                type: 'String',
                values: []
            };
        }

        let pendingtags = [];
        for (let i = 0; i < tags.length; i++) {
            let tag = tags[i];

            let currentTags;
            if (Array.isArray(currentFile.tags)) {
                currentTags = currentFile.tags;
            } else {
                currentTags = currentFile.tags.values;
            }

            if (currentTags.indexOf(tag) === -1) {
                pendingtags.push(tag);
                currentTags.push(tag);
            }
        }

        let promise = FileService.addTagToFile(currentFile.fileId, pendingtags).catch(err => {
            console.log('err', err);
            return oldFile;
        });

        return { tempState: currentFile, promise };

        // try {
        //     let response = await FileService.addTagToFile(
        //         currentFile.fileId,
        //         pendingtags
        //     );
        //     return response;
        // } catch (err) {
        //     console.log('err', err);
        //     currentFile.tags = oldTags;
        //     return currentFile;
        // }
    };

    deleteFile = async currentFile => {
        if (!currentFile.inUse) {
            try {
                let response = await FileService.deleteFile(currentFile.fileId);
                return response;
            } catch (err) {
                console.log('err', err);
                return 'Error: ' + err.message;
            }
        } else {
            //TODO: file in use!! cannot be deleted!
            return 'Error: This file can not be deleted because it is in use.';
        }
    };

    updateFile = async (currentFile, newFile, fileProgressCallback) => {
        if (newFile.name.split('.').pop() === currentFile.filename.split('.').pop()) {
            let fileId = currentFile.fileId;
            try {
                let response = await FileService.replaceFile(fileId, newFile, newFile.name, newFile.type, undefined, fileProgressCallback);
                return response;
            } catch (err) {
                console.log('err', err);
                return 'uploadFileError';
            }
        } else {
            return 'sameFileTypeError';
        }
    };

    changeGroup = async (currentFile, newGroup) => {
        const oldFile = cloneDeep(currentFile);
        try {
            return await FileService.changeGroup(currentFile.fileId, newGroup);
        } catch (err) {
            console.log('err', err);
            return oldFile;
        }
    };

    removeGroup = async currentFile => {
        const oldFile = cloneDeep(currentFile);
        try {
            return await FileService.removeGroup(currentFile.fileId);
        } catch (err) {
            console.log('err', err);
            return oldFile;
        }
    };
}

export default UpdateFileController;
